/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { VerifyNameNotification } from '@coursera-web/certificate-common';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/accomplishments';

type PropsFromCaller = {
  open: boolean;
  /**
   * A boolean indicating whether the current user is the owner of the certificate
   */
  isCertificateOwner: boolean;
  onClose: () => void;
};

const styles = {
  content: css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const VerificationIncompleteModal = ({ open, onClose, isCertificateOwner }: PropsFromCaller) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Dialog.HeadingGroup>{_t('Verification not complete')}</Dialog.HeadingGroup>
      <Dialog.Content>
        <Typography2 component="p" css={styles.content}>
          {_t(
            'This user has not completed verifying their account. Their name will not appear on this certificate until they complete verification.'
          )}
        </Typography2>
        {isCertificateOwner && <VerifyNameNotification />}
      </Dialog.Content>
      <Dialog.Actions>
        <Button variant="secondary" data-testid="close-cta" onClick={onClose}>
          {_t('Close')}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default VerificationIncompleteModal;
